import {type MessageDescriptor} from '@lingui/core'
import {msg} from '@lingui/core/macro'

export class ClassroomApiError extends Error {
  code: string
  status: number

  constructor(code: string, status: number, message?: string) {
    super(message ?? code)
    this.name = 'ClassroomApiError'
    this.code = code
    this.status = status
  }
}

const MESSAGES: Record<string, MessageDescriptor> = {
  CodeRequired: msg`This classroom needs a join code. Ask the teacher for it.`,
  CodeInvalid: msg`That code doesn’t match. Check it with your teacher and try again.`,
  LevelUnknown: msg`Tell us your class year first, so we can find the right classrooms for you.`,
  LevelMismatch: msg`This classroom is for another class year.`,
  CountryMismatch: msg`This classroom is for learners in another country.`,
  ParentsNotAllowed: msg`This classroom isn’t open to parents.`,
  NoLinkedChild: msg`Link your child’s account first, then you can join their classroom.`,
  OwnerCannotJoin: msg`You run this classroom already.`,
  Forbidden: msg`You can’t do that in this classroom.`,
  NotFound: msg`This classroom doesn’t exist any more.`,
  NoRequest: msg`Already handled.`,
  LevelChangeLocked: msg`The level can be changed again in a few days.`,
  ParentsHoldSeats: msg`Parents are in this classroom. Remove them first.`,
}

const FALLBACK = msg`Something went wrong. Please try again.`

export function classroomErrorMessage(
  l: (d: MessageDescriptor | TemplateStringsArray) => string,
  code: string,
): string {
  return l(Object.hasOwn(MESSAGES, code) ? MESSAGES[code] : FALLBACK)
}
